var map = {
	"./at.svg": "fd7c",
	"./be.svg": "72f4",
	"./bg.svg": "400b",
	"./ch.svg": "b0bd",
	"./cz.svg": "1d35",
	"./de.svg": "8059",
	"./dk.svg": "cd7f",
	"./ee.svg": "01f5",
	"./es.svg": "28a4",
	"./fi.svg": "3f0a",
	"./fr.svg": "c541",
	"./gr.svg": "cdf6",
	"./hr.svg": "0401",
	"./hu.svg": "30a6",
	"./it.svg": "ff8e",
	"./li.svg": "43e0",
	"./lt.svg": "5606",
	"./lu.svg": "c8fe",
	"./lv.svg": "3e11",
	"./mk.svg": "785b",
	"./nl.svg": "fdcb",
	"./no.svg": "67af",
	"./pl.svg": "49f7",
	"./pt.svg": "07c7",
	"./ro.svg": "afff",
	"./rs.svg": "e5c6",
	"./ru.svg": "249c",
	"./se.svg": "2f2a",
	"./si.svg": "c871",
	"./sk.svg": "e9ab",
	"./sm.svg": "d2cf",
	"./ua.svg": "8c75"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f6e9";